import { createMetricsFactory } from 'metrics-js';
const Metrics = createMetricsFactory('usage-based-billing-components', {
  library: 'usage-based-billing-components-lib'
});
export default Metrics;